module.exports = __webpack_public_path__ + "static/media/global-shoppng-11.61e89c77.png";